var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6312,
    cy: 4.38934,
    r: 3.41393,
    fill: "#01E69C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.9467,
    cy: 2.92623,
    r: 2.92623,
    fill: "#01E69C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.31557,
    cy: 2.92623,
    r: 2.92623,
    fill: "#01E69C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34015 14.6311C6.34015 11.3989 8.96038 8.77869 12.1926 8.77869H17.0697C20.3019 8.77869 22.9221 11.3989 22.9221 14.6311H6.34015Z",
    fill: "#01E69C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2113 7.61247L9.7541 6.9267C3.12131 6.14638 0.487705 10.1781 0 12.2915H4.87705C4.87705 12.2915 6.51748 9.0106 9.79833 8.46599C10.1923 8.40059 10.4328 7.94475 10.2113 7.61247Z",
    fill: "#01E69C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4961 7.73679L19.9959 6.93374C26.6287 6.09787 29.2623 10.4165 29.75 12.6803H24.873C24.873 12.6803 23.2211 9.14154 19.9175 8.57662C19.5308 8.5105 19.2888 8.06985 19.4961 7.73679Z",
    fill: "#01E69C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.6ebb8e0daae5d7acfdb49246fe6e8d94.svg";
export { ForwardRef as ReactComponent };